import { ReactNode } from 'react';

interface MetricCardProps {
  label: string;
  value: string;
  hint?: string;
  icon?: ReactNode;
  tone?: 'neutral' | 'green' | 'amber' | 'red' | 'blue';
}

export function MetricCard({ label, value, hint, icon, tone = 'neutral' }: MetricCardProps) {
  return (
    <section className={`metric metric-${tone}`}>
      <div className="metric-head">
        <span className="metric-icon">{icon}</span>
        <span className="metric-label">{label}</span>
      </div>
      <div className="metric-value">{value}</div>
      {hint ? <div className="metric-hint">{hint}</div> : null}
    </section>
  );
}
